import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function GuaranteeSection() {
  return <section className="border-y border-slate-700/60 bg-slate-900 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-79" data-mp="9umh8ubc1s8c">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-80" data-mp="etpo8kavi8iy">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-slate-600 bg-slate-950 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-81" data-mp="er35doij86lf">
          <span className="inline-flex rounded-full border border-amber-400/50 bg-slate-900 p-4 text-amber-400" data-id="element-82" data-mp="xivz5l5fdvu7">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-83" data-mp="12klc56c7kjkx" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-84" data-mp="17iwllfylcs2m">
            7-Day <span className="text-amber-400" data-id="element-85" data-mp="25pu8j9axzig0">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-86" data-mp="20s2fgbyk9qa8">
            Study all 6 volumes and 5 bonuses of {productShortName} this week. If the technical depth doesn&apos;t match
            your professional needs,{' '}
            <span className="font-extrabold text-amber-400" data-id="element-87" data-mp="1ruihpczwqc4d">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}